import Toast from 'component/toast';
import {SetterOrUpdater} from 'recoil';
import {_goToRoot} from 'router/helper';

type ParamsT = {
  cart: CartDataT;
  setCart: SetterOrUpdater<CartDataT>;
  message?: string;
};

export const onCartRes = (params: ParamsT) => {
  params.setCart(params.cart);
};

export const onChangeCartItemRes = (args: ParamsT) => onCartRes(args);

export const onRemoveCartRes = (args: ParamsT) => onCartRes(args);

export const onRemoveCartItemRes = (args: ParamsT) => onCartRes(args);

export const onCartCompletionRes = (args: ParamsT) => {
  Toast.success({message: args.message});
  onCartRes(args);
  _goToRoot();
};
